import { OTP_COMPLETE_EVENT } from "./events/OtpCompleteEvent";
import { OTP_FAIL_EVENT } from "./events/OtpFailEvent";
import { OtpRequestEvent } from "./events/OtpRequestEvent";

export async function requestOtp(apiPath?: string) {
  return new Promise<void>((resolve, reject) => {
    document.dispatchEvent(new OtpRequestEvent(apiPath));

    const resolveHandler = () => {
      resolve();
      document.removeEventListener(OTP_COMPLETE_EVENT, resolveHandler);
      document.removeEventListener(OTP_FAIL_EVENT, rejectHandler);
    };

    const rejectHandler = () => {
      reject();
      document.removeEventListener(OTP_COMPLETE_EVENT, resolveHandler);
      document.removeEventListener(OTP_FAIL_EVENT, rejectHandler);
    };

    document.addEventListener(OTP_COMPLETE_EVENT, resolveHandler);
    document.addEventListener(OTP_FAIL_EVENT, rejectHandler);
  });
}
